import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-talent",
  templateUrl: "./talent.component.html",
  styleUrls: ["./talent.component.css"],
})
export class TalentComponent implements OnInit {
  constructor(public router: Router) {}

  ngOnInit(): void {
    document.documentElement.style.setProperty(
      "--color",
      !(this.router.url === "/home" || this.router.url === "/")
        ? "black"
        : "white"
    );
  }
}
